<template>
  <div id="app">
    <!-- <router-view /> -->
    <keep-alive v-if="$route.meta.keepAlive">
      <router-view></router-view>
    </keep-alive>
    <router-view :key="$route.fullPath" v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
import { removeWatermark, setWaterMark } from '@/utils/watermark'
export default {
  name: 'App',
  created () {
    // 用于钉钉jssdk鉴权，必修记录首次加载的地址
    window.globalurls = window.location.href
    const obj = localStorage.getItem("sysShuiYin");
    if(obj && JSON.parse(obj)){
      const nobj = JSON.parse(obj)
      if(nobj.show_watermark == 1){
        setWaterMark(
          nobj.watermark_line1,
          nobj.watermark_line2,
          nobj.watermark_line3
        )
      }
    }
  }
}
</script>
<style lang="less">
.workFlowContainer *{
  user-select: text !important;
}
.workFlowContainer{
  .van-field__control{
    pointer-events: auto !important;
  }
}

#app {
  height: 100%;
  overflow: auto;
}
.win_tree_popup{
  z-index: 999999 !important;
}
.win_tree_popup_overlay{
  z-index: 99999 !important;
}
// #v8_qrcode {
//   width: 4.52rem !important;
//   height: 4.52rem !important;
//   margin: 0 auto !important;
//   img {
//     width: 4.52rem !important;
//     height: 4.52rem !important;
//   }
//   canvas {
//     width: 4.52rem !important;
//     height: 4.52rem !important;
//   }
// }
[class*=van-hairline]::after{
  border: none !important;
}
.van-toast {
  width: 50% !important;
}
.van-popover__action-text{
  justify-content: left !important;
  text-align: justify !important;
  word-break: break-all !important;
}
.MYNewsDetails {
  img {
    height: auto !important;
    width: 100%;
  }
  p {
    line-height: 1.5 !important;
    margin: 0 !important;
  }
}
.mspj-super-class {
  margin-bottom: 30px;
  .van-cell__title {
    text-align: left !important;
  }
  .van-collapse-item__content {
    text-align: left !important;
  }
}

.wddqwqwdwdqw {
  color: red !important;
}
.hideNfLLL{
  .van-picker__columns{
    .van-picker-column{
      &:nth-child(2){
        display: none !important;
      }
    }
  }
}
.windowImagePreviewClassName{
  .van-image__img{
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    margin: auto;
  }
}
.van-toast--unclickable *{
  pointer-events: all !important;
}
.vc-switch{
  z-index: 999999999999 !important;
}
#__vconsole{
  position: relative !important;
  z-index: 99999999999 !important;
}
.van-picker-column__item--selected{
  background: #EFF7FF !important;
  color: #1890FF !important;
}
.winAllSelectZindex{
  z-index: 999999 !important;
}
.winAllSelectZindexDiv{
  z-index: 9999999 !important;
}
.ToastZindexMax{
  z-index: 99999999 !important;
}
.van-image-preview__overlay{
  background-color: rgba(0,0,0,.5) !important;
}
.markdown-body ul,
.markdown-body ol {
  margin-top: 0;
  margin-bottom: 0;
  li {
    list-style: auto !important;
  }

}

.markdown-body ol ol,
.markdown-body ul ol {
  list-style-type: lower-roman;
}

.markdown-body ul ul ol,
.markdown-body ul ol ol,
.markdown-body ol ul ol,
.markdown-body ol ol ol {
  list-style-type: lower-alpha;
}
.markdown-body h1{
  font-size: 1.3em !important;
}
.markdown-body h2{
  font-size: 1.2em !important;
}
.markdown-body h3{
  font-size: 1.1em !important;
}
.markdown-body h4{
  font-size: 1em !important;
}
.markdown-body h5{
  font-size: 1em !important;
}
.markdown-body h6{
  font-size: 1em !important;
}
.inputType15{
  .van-field__control{
    overflow: hidden !important;
  }
}

</style>
